import { useState } from 'react'

const Navigation = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false)

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen)
  }

  return (
    <>
      <section className="navigation fixed top-0 left-0 right-0 z-[60]">
        <div className="nav-bar bg-white/95 backdrop-blur-lg shadow-sm">
          <div className="container mx-auto px-4 py-4 flex items-center justify-between">
            {/* Logo */}
            <a href="/" className="logo-link flex items-center">
              <img src="/assets/logowithouttext.svg" alt="oneAI Consulting" className="h-10 w-auto" />
            </a>

            {/* Menu Button */}
            <div className="button-menu cursor-pointer" onClick={toggleMenu}>
              <div className="menu-icon-wrap">
                <div className="menu-icon">
                  <div className={`w-6 h-0.5 bg-gray-800 transition-all duration-300 ${isMenuOpen ? 'rotate-45 translate-y-1.5' : ''}`}></div>
                  <div className={`w-6 h-0.5 bg-gray-800 mt-1.5 transition-all duration-300 ${isMenuOpen ? '-rotate-45 -translate-y-1.5' : ''}`}></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      {/* Navigation Menu Drawer */}
      <div className={`nav-content fixed top-0 right-0 h-full w-96 bg-white shadow-2xl transform transition-transform duration-300 ${isMenuOpen ? 'translate-x-0' : 'translate-x-full'} flex flex-col p-8 z-50`}>
        <div className="nav-link-list flex-1 pt-16">
          <div className="nav-link-item mb-6">
            <a href="/" className="nav-link block text-2xl font-semibold text-gray-800 hover:text-blue-600 transition-colors">
              Home
            </a>
          </div>
          <div className="nav-link-item mb-6">
            <a href="/about" className="nav-link block text-2xl font-semibold text-gray-800 hover:text-blue-600 transition-colors">
              About
            </a>
          </div>
          <div className="nav-link-item mb-6">
            <a href="/services" className="nav-link block text-2xl font-semibold text-gray-800 hover:text-blue-600 transition-colors">
              Services
            </a>
          </div>
          <div className="nav-link-item mb-6">
            <a href="/solutions" className="nav-link block text-2xl font-semibold text-gray-800 hover:text-blue-600 transition-colors">
              Solutions
            </a>
          </div>
          <div className="nav-link-item mb-6">
            <a href="/blog" className="nav-link block text-2xl font-semibold text-gray-800 hover:text-blue-600 transition-colors">
              Blog
            </a>
          </div>
          <div className="nav-link-item mb-6">
            <a href="/contact" className="nav-link block text-2xl font-semibold text-gray-800 hover:text-blue-600 transition-colors">
              Contact
            </a>
          </div>
        </div>
        
        {/* Social Icons */}
        <div className="social-icons-wrap">
          <a href="https://linkedin.com/company/oneai-consulting" target="_blank" rel="noopener noreferrer" className="social-icon-link inline-block w-10 h-10 text-gray-600 hover:text-blue-600 transition-colors">
            <svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fillRule="evenodd" clipRule="evenodd" d="M4.5 3C3.67157 3 3 3.67157 3 4.5V19.5C3 20.3284 3.67157 21 4.5 21H19.5C20.3284 21 21 20.3284 21 19.5V4.5C21 3.67157 20.3284 3 19.5 3H4.5ZM8.52076 7.00272C8.52639 7.95897 7.81061 8.54819 6.96123 8.54397C6.16107 8.53975 5.46357 7.90272 5.46779 7.00413C5.47201 6.15897 6.13998 5.47975 7.00764 5.49944C7.88795 5.51913 8.52639 6.1646 8.52076 7.00272ZM12.2797 9.76176H9.75971H9.7583V18.3216H12.4217V18.1219C12.4217 17.742 12.4214 17.362 12.4211 16.9819V16.9818V16.9816V16.9815V16.9812C12.4203 15.9674 12.4194 14.9532 12.4246 13.9397C12.426 13.6936 12.4372 13.4377 12.5005 13.2028C12.7381 12.3253 13.5271 11.7586 14.4074 11.8979C14.9727 11.9864 15.3467 12.3141 15.5042 12.8471C15.6013 13.1803 15.6449 13.5389 15.6491 13.8863C15.6605 14.9339 15.6589 15.9815 15.6573 17.0292V17.0294C15.6567 17.3992 15.6561 17.769 15.6561 18.1388V18.3202H18.328V18.1149C18.328 17.6629 18.3278 17.211 18.3275 16.7591V16.759V16.7588C18.327 15.6293 18.3264 14.5001 18.3294 13.3702C18.3308 12.8597 18.276 12.3563 18.1508 11.8627C17.9638 11.1286 17.5771 10.5211 16.9485 10.0824C16.5027 9.77019 16.0133 9.5691 15.4663 9.5466C15.404 9.54401 15.3412 9.54062 15.2781 9.53721L15.2781 9.53721L15.2781 9.53721C14.9984 9.52209 14.7141 9.50673 14.4467 9.56066C13.6817 9.71394 13.0096 10.0641 12.5019 10.6814C12.4429 10.7522 12.3852 10.8241 12.2991 10.9314L12.2991 10.9315L12.2797 10.9557V9.76176ZM5.68164 18.3244H8.33242V9.76733H5.68164V18.3244Z" fill="currentColor"></path>
            </svg>
          </a>
        </div>
      </div>

      {/* Full Page Overlay - covers entire viewport including page content */}
      {isMenuOpen && (
        <div className="menu-overlay fixed inset-0 bg-black bg-opacity-50 z-40" onClick={toggleMenu}></div>
      )}
    </>
  )
}

export default Navigation
